import GROW_2792_EXPERIMENT_TOOLTIP_COPY from '~pricing/experiments/grow_2792_pnp_refresh_v1/copy/experimentTooltipCopy';

const EXPERIMENT_TOOLTIP_COPY = {
  ...GROW_2792_EXPERIMENT_TOOLTIP_COPY,
};

export default EXPERIMENT_TOOLTIP_COPY;
